import { render } from "./Index_news_m.vue?vue&type=template&id=d9afd584&scoped=true"
import script from "./Index_news_m.vue?vue&type=script&lang=js"
export * from "./Index_news_m.vue?vue&type=script&lang=js"

import "./Index_news_m.vue?vue&type=style&index=0&id=d9afd584&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9afd584"

export default script